export const formatBytes = (size: number, accuracy = 2): string => {
    const fixedAccuracy: number = accuracy < 0 ? 0 : accuracy;
    const unitNumber = Math.floor(Math.log(size) / Math.log(1024));
    const unit = ["Bytes", "KB", "MB", "GB", "TB"][unitNumber];

    return `${parseFloat((size / Math.pow(1024, unitNumber)).toFixed(fixedAccuracy))} ${unit}`;
};
